module.exports = __webpack_public_path__ + "static/img/4-3.2e1d4df.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/4-3.png
// module id = 270
// module chunks = 0